function isEmpty(text) {
  const matchSpace = /^\s*(?!.)/.test(text);
  return text.length === 0 || (text.length > 0 && matchSpace);
}

export default isEmpty;
